import { createContext } from 'react'
import { ContextData } from './types'

const Context = createContext<ContextData>({
    onClick: () => null,
    className: '',
    type: 'option',
    disabled: false
})

export default Context
